import { createSlice } from "@reduxjs/toolkit";

const initialConsolidationExportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  consolidationExportForEdit: undefined,
  lastError: null,
  // ! PROGRAM, DONOR, DONATION COUNT
  donorCount: 0,
  donationCount: 0,
  programCount: 0,
  // ? LIBRARY FILES
  consolidationExportFiles: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminConsolidationExportSlice = createSlice({
  name: "consolidationExport",
  initialState: initialConsolidationExportState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getconsolidationExportById
    consolidationExportFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.consolidationExportForEdit =
        action.payload.consolidationExportForEdit;
      state.donorCount = action.payload.donorCount;
      state.donationCount = action.payload.donationCount;
      state.programCount = action.payload.programCount;
    },
    // findconsolidationExport
    consolidationExportsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    consolidationExportReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
    consolidationExportFiles: (state, action) => {
      state.consolidationExportFiles = action.payload.items;
      state.totalCount = action.payload.total_items;
      state.listLoading = false;
      state.actionsLoading = false;
    },
    consolidationExportFilesFetched: (state, action) => {
      state.consolidationExportFiles = action.payload.items;
      state.listLoading = false;
      state.actionsLoading = false;
    }
  }
});
